import Cookies from 'js-cookie';
import { logRollout } from './rolloutLog';
import { configGetRolloutRedirectUrl } from '../services/ConfigProvider';
import { ServerSettings } from '../services/types';

export const LEAN_PDP_COOKIE = 'ff_lean_pdp_v4';
const FALLBACK_VARIANT = 'control';

// Flows the Lean front has no page for: redirecting them lands on its
// catch-all, which turns the path (and the restore key) into a search.
const ROLLOUT_EXCLUDED_PATHS = [
  /^\/restore-password(\/|$)/,
  /^\/delete-account(\/|$)/,
];

export function isRolloutExcludedPath(pathname: string): boolean {
  return ROLLOUT_EXCLUDED_PATHS.some((path) => path.test(pathname));
}

async function fetchSettings(): Promise<ServerSettings | null> {
  try {
    const response = await fetch('/settings.json');
    return await response.json();
  } catch {
    return null;
  }
}

export async function redirectLegacyUserToRollout(): Promise<boolean> {
  if (isRolloutExcludedPath(window.location.pathname)) return false;

  let variant = Cookies.get(LEAN_PDP_COOKIE);
  const cookieIn = variant;

  if (!variant) {
    variant = FALLBACK_VARIANT;
    Cookies.set(LEAN_PDP_COOKIE, variant, {
      domain: '.dafiti.com.br',
      expires: 1 / 12,
      path: '/',
      sameSite: 'lax',
      secure: true,
    });
  }

  logRollout(cookieIn, variant, Cookies.get(LEAN_PDP_COOKIE));
  if (variant !== 'on') return false;

  // Only Lean users wait for settings.json; without a target they stay here.
  const target = configGetRolloutRedirectUrl(await fetchSettings());
  if (!target) {
    console.warn(
      '[rollout] REACT_APP_ROLLOUT_REDIRECT_URL missing from settings.json; serving legacy login',
    );
    return false;
  }

  window.location.replace(
    `${target}${window.location.pathname}${window.location.search}${window.location.hash}`,
  );
  return true;
}
